export default __webpack_public_path__ + "static/media/single.ea0395a3.png";